import Image from 'next/image';

import { Grid, Typography, colors } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';

import PropTypes from 'prop-types';
import SwiperCore, { Navigation } from 'swiper';
import { Swiper, SwiperSlide } from 'swiper/react';

import { SectionHeader, IconAlternate } from '@/src/components/molecules';

SwiperCore.use([Navigation]);

const useStyles = makeStyles(theme => ({
  swiper: {
    '--swiper-theme-color': `${theme.palette.primary.main} !important`,
  },
  swiperSlide: {
    display: 'grid',
    justifyContent: 'center',
    width: 'auto',
  },
  swiperContainer: {
    width: '100%',
    maxWidth: 500,
  },
  imageWrapper: {
    position: 'relative',
    marginTop: theme.spacing(4),
    height: 150,
    width: 150,
  },
}));

export default function Reviews(props) {
  const { data, className, ...rest } = props;
  const classes = useStyles();

  return (
    <div className={className} data-aos="fade-up" {...rest}>
      <SectionHeader
        title="Saiba o que nossos parceiros falam sobre nós"
        subtitle="Nossa plataforma atende diversos cenários complexos de venda, característicos do setor educacional, e entregamos uma operação simples e fácil para nossos parceiros."
      />
      <Swiper slidesPerView={1} navigation className={classes.swiper}>
        {data.map((item, index) => (
          <SwiperSlide key={index.toString()} className={classes.swiperSlide}>
            <Grid
              container
              justifyContent="center"
              justifyItems="center"
              spacing={4}
              className={classes.swiperContainer}>
              <Grid item>
                <IconAlternate color={colors.indigo} fontIconClass="fas fa-quote-right" />
              </Grid>
              <Grid item>
                <Typography variant="h6" align="center">
                  {item.feedback}
                </Typography>
              </Grid>
              <Grid item container spacing={4} justifyContent="center" alignItems="center">
                <Grid item className={classes.imageWrapper}>
                  <Image
                    src={item.authorPhoto?.src}
                    alt={item.authorOccupation}
                    layout="fill"
                    objectFit="contain"
                  />
                </Grid>
                <Grid item>
                  <Typography variant="subtitle1" noWrap>
                    {item.authorName}
                  </Typography>
                  <Typography variant="subtitle2" color="textSecondary" noWrap>
                    {item.authorOccupation}
                  </Typography>
                </Grid>
              </Grid>
            </Grid>
          </SwiperSlide>
        ))}
      </Swiper>
    </div>
  );
}

Reviews.propTypes = {
  className: PropTypes.string,
  data: PropTypes.array.isRequired,
};
